import { useState } from "react";

export default function Produktbeispiele() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const items = [
    { id: 1, title: "Produktion - ein Logo entseht", src: "/bilder/moser_produktion.webp"},
    { id: 2, title: "Weste", src: "/bilder/IMG_0592.webp" },
    { id: 3, title: "Einzelanfertigung Hoodie", src: "/bilder/IMG_2724.webp" },
    { id: 4, title: "vom Polo bis zum 'Maßkrugbandl'", src: "/bilder/Wiesenbach.webp" },
    { id: 5, title: "Praxis - Polo", src: "/bilder/IMG-20201024-WA0014.webp" },
    { id: 6, title: "Farbvarianten beim Firmenlogo", src: "/bilder/IMG-20191018-WA0017.webp" },
    { id: 7, title: "Gastronomie", src: "/bilder/spargel_hof.webp" },
    { id: 8, title: "Mützen mit Firmenlogo", src: "/bilder/IMG_E7596.webp" },
    { id: 9, title: "Trachten- Verein Hemd & Polo", src: "/bilder/IMG_3242.webp" },
    { id: 10, title: "Detail - Ansicht", src: "/bilder/IMG_20200925_140702.webp" },
    { id: 11, title: "Schützenverein - Hemd- Ärmel", src: "/bilder/IMG_5397.webp" },
    { id: 12, title: "Dirndl - Schürzen", src: "/bilder/P1020264.webp" },
    { id: 13, title: "Zur Wiesn - mit der Firma 'Maßkrugbandl'", src: "/bilder/18_Kateg._ A_Hirschen_t.webp" },
    { id: 14, title: "mit'm 'Mini Maßkrugbandl' auf's Firmen-Event", src: "/bilder/IMG_3304.webp" },
    { id: 15, title: " Alle Bänder werden einzeln gefertigt ", src: "/bilder/IMG_5806.webp" },
    { id: 16, title: "mit der Firma auf die Wies'n", src: "/bilder/wiesn.webp" },
    { id: 17, title: "Baby - Handtuch ", src: "/bilder/IMG_20210303_091517.webp" },
    { id: 18, title: "zum Sport ausgerüstet", src: "/bilder/mr63.webp" },
    { id: 19, title: "praktischer Begleiter ", src: "/bilder/IMG_E7509.webp" },
    { id: 20, title: "mit Farbe zum Blickfang", src: "/bilder/IMG_2724.webp" },
    { id: 21, title: "Beispiel Pferdeschabracke -  Sponsoring", src: "/bilder/IMG_8016.webp" },
    { id: 22, title: "Sonderanfertigung für besondere Anlässe", src: "/bilder/Hochzeit004.webp" },
    { id: 23, title: "Ihre Firma in Szene gesetzt ", src: "/bilder/GAGU_Juli.webp" },
    { id: 24, title: "Give Away", src: "/bilder/IMG_1845.webp" },
    /*{ id: 25, title: "Ald", src: "/bilder/IMG_3287.webp" },
    { id: 26, title: "g", src: "/bilder/IMG_3324.webp" },
    { id: 27, title: "Pferde Schabracke Hero", src: "/bilder/IMG_8010.webp" },
    { id: 28, title: "Pferde Schabracke Hero", src: "/bilder/IMG_8016.webp" },
    { id: 29, title: "Altagshilfen", src: "/bilder/P1080669.webp" },
    { id: 30, title: "Altagshilfen", src: "/bilder/P1080669.webp" },*/
  ];

  const openLightbox = (id: number) => {
    setSelectedImage(id);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const currentItem = selectedImage ? items.find((it) => it.id === selectedImage) : null;

  return (
    <section className="section">
      <div className="container">
        <h2>Produktbeispiele</h2>
        <p>Hier sehen Sie exemplarische Arbeiten. Fragen Sie gerne wenn Sie nach etwas speziellem suchen.</p>
        <div className="gallery">
          {items.map((it) => (
            <figure
              key={it.id}
              className="gallery__item"
              onClick={() => openLightbox(it.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && openLightbox(it.id)}
            >
              <img src={it.src} alt={it.title} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && currentItem && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox__content" onClick={(e) => e.stopPropagation()}>
            <button
              className="lightbox__close"
              onClick={closeLightbox}
              aria-label="Lightbox schliessen"
            >
              X
            </button>
            <img src={currentItem.src} alt={currentItem.title} className="lightbox__image" />
            <p className="sr-only">{currentItem.title}</p>
          </div>
        </div>
      )}
    </section>
  );
}


